import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	timezone: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.timezone.timezone',
		defaultMessage: 'Timezone',
		description: 'label for timezone field',
	},
});
